var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9316_96466)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9316_96466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5293,
    y: 59.7727,
    width: 284.36,
    height: 112.227,
    rx: 6.06635,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.928,
    cy: 92.379,
    r: 24.2654,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.052,
    y: 68.1136,
    width: 72.0379,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.639,
    y: 68.1136,
    width: 6.82464,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.497,
    y: 68.1136,
    width: 6.82464,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.052,
    y: 81.0048,
    width: 51.564,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.052,
    y: 128.018,
    width: 200.948,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.052,
    y: 135.602,
    width: 200.948,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.052,
    y: 143.184,
    width: 58.3886,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.052,
    y: 154.559,
    width: 110.711,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.663,
    y: 128.018,
    width: 48.5308,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.663,
    y: 154.559,
    width: 48.5308,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_9316_96466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.7812,
    y: 38.54,
    width: 284.36,
    height: 112.227,
    rx: 6.06635,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.179,
    cy: 71.1465,
    r: 24.2654,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.304,
    y: 46.8811,
    width: 72.0379,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.891,
    y: 46.8811,
    width: 6.82464,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.749,
    y: 46.8811,
    width: 6.82464,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.304,
    y: 59.7728,
    width: 51.564,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.304,
    y: 106.786,
    width: 200.948,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.304,
    y: 114.369,
    width: 200.948,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.304,
    y: 121.953,
    width: 58.3886,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.304,
    y: 133.327,
    width: 110.711,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9141,
    y: 106.786,
    width: 48.5308,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9141,
    y: 133.327,
    width: 48.5308,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_9316_96466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 12,
    width: 284.36,
    height: 112.227,
    rx: 6.06635,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9316_96466)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.3992,
    cy: 44.6062,
    r: 24.2654,
    fill: "#8A75F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6918 69.3774C60.7734 73.2724 61.3341 78.6254 65.7185 80.0324C66.9757 80.3327 68.2821 80.3639 69.5522 80.1242C70.703 80.028 71.8596 80.2208 72.917 80.685C75.2927 81.623 77.4237 82.7854 80.0543 82.867C82.6031 82.9154 85.1018 82.1551 87.1916 80.6952C87.9359 80.1956 89.0473 79.1352 90.0363 79.2371C91.0253 79.3391 91.8818 80.2567 92.7485 80.6034C98.0403 82.7344 100.324 76.321 100.722 72.3343C101.619 63.1578 96.6434 54.073 90.1791 47.8635V47.7922C90.4779 47.0065 90.64 46.1753 90.6583 45.3349C90.8152 44.1314 91.078 42.944 91.4434 41.7866C92.0959 39.9004 93.6967 38.5035 94.7775 36.8619C95.7782 35.4181 96.2663 33.6807 96.1642 31.927C96.1317 31.1381 95.9224 30.3667 95.5518 29.6696C95.1812 28.9725 94.6587 28.3676 94.023 27.8995C92.4936 26.8799 90.5665 27.0226 88.8026 26.992C85.1626 26.9308 81.2778 26.523 77.7092 27.4203C76.0071 27.834 74.4435 28.6875 73.1748 29.8953C71.9061 31.1031 70.9769 32.6229 70.4801 34.3027C69.4605 37.5144 69.0118 41.96 70.3781 45.1106L69.9397 45.3859C68.9284 46.0518 67.9887 46.8206 67.1358 47.68C65.5659 49.3349 64.2839 51.2406 63.3428 53.3185C61.0486 58.3758 60.6204 63.9225 60.6918 69.3774Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8645 38.0139C87.8645 38.0139 89.4143 49.2297 84.306 50.912C80.2276 52.2579 76.0574 48.7301 74.9766 41.5622",
    stroke: "#00005A",
    strokeWidth: 1.13744,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7787 82.8769C68.7787 82.8769 60.4281 57.4986 74.9576 50.9221",
    stroke: "#00005A",
    strokeWidth: 1.13744,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.415 52.7781C93.9421 55.6534 99.4175 62.9742 96.328 81.725",
    stroke: "#00005A",
    strokeWidth: 1.13744,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8724 68.3678C91.8724 68.3678 93.9116 79.5836 80.6566 79.5836C76.6597 79.5836 73.3867 79.2573 72.1836 66.3286",
    stroke: "#00005A",
    strokeWidth: 1.13744,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9679 44.6213C71.6933 43.362 70.8689 41.718 70.622 39.9433C70.375 38.1686 70.7193 36.3619 71.6016 34.8024C70.8176 34.583 70.1121 34.1452 69.5675 33.54C69.0229 32.9348 68.6617 32.1872 68.5259 31.3844C68.3902 30.5817 68.4855 29.7568 68.8008 29.0062C69.1161 28.2556 69.6384 27.6101 70.3067 27.1451C74.7522 24.0863 76.7405 31.5295 76.7405 31.5295C82.7256 27.1247 88.6292 28.5726 88.1092 33.1711C87.4056 39.4519 78.1067 36.7907 78.1067 36.7907C77.8289 37.5367 77.3268 38.1783 76.6695 38.6274C76.0123 39.0765 75.2321 39.3111 74.4361 39.2989",
    stroke: "#00005A",
    strokeWidth: 1.13744,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 114.521,
    y: 20.3408,
    width: 72.0379,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.109,
    y: 20.3408,
    width: 6.82464,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.967,
    y: 20.3408,
    width: 6.82464,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.521,
    y: 33.2322,
    width: 51.564,
    height: 6.82464,
    rx: 3.41232,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.521,
    y: 80.2462,
    width: 200.948,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.521,
    y: 87.8293,
    width: 200.948,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.521,
    y: 95.4125,
    width: 58.3886,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.521,
    y: 106.786,
    width: 110.711,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1338,
    y: 80.2462,
    width: 48.5308,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1338,
    y: 106.786,
    width: 48.5308,
    height: 4.54976,
    rx: 2.27488,
    fill: "#DEE4ED"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9316_96466",
    x: 70.3597,
    y: 40.3743,
    width: 328.7,
    height: 156.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.7712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0848
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14 0 0 0 0 0.304348 0 0 0 0 0.56 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9316_96466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.305882 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9316_96466",
    result: "effect2_dropShadow_9316_96466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9316_96466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_9316_96466",
    x: 47.6116,
    y: 19.1416,
    width: 328.7,
    height: 156.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.7712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0848
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14 0 0 0 0 0.304348 0 0 0 0 0.56 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9316_96466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.305882 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9316_96466",
    result: "effect2_dropShadow_9316_96466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9316_96466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_9316_96466",
    x: 21.8304,
    y: -7.39843,
    width: 328.7,
    height: 156.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.7712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0848
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14 0 0 0 0 0.304348 0 0 0 0 0.56 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9316_96466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.305882 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9316_96466",
    result: "effect2_dropShadow_9316_96466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9316_96466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9316_96466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9316_96466"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.1338,
    y: 20.3408,
    width: 48.5308,
    height: 48.5308,
    rx: 24.2654,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateContacts);
export default __webpack_public_path__ + "static/media/empty-state-contacts.3438ee33d84a10c2f47142d2783e0d29.svg";
export { ForwardRef as ReactComponent };